var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76739 10.2766C6.81338 10.3408 6.87401 10.3931 6.94425 10.4291C7.01449 10.4652 7.09232 10.4841 7.17129 10.4841C7.25026 10.4841 7.32809 10.4652 7.39833 10.4291C7.46858 10.3931 7.52921 10.3408 7.5752 10.2766L10.8658 5.71406C10.9252 5.63125 10.8658 5.51562 10.7643 5.51562H10.0314C9.87207 5.51562 9.72051 5.59219 9.62676 5.72344L7.17207 9.12969L6.05957 7.58594C5.96582 7.45625 5.81582 7.37813 5.65489 7.37813H4.92207C4.82051 7.37813 4.76114 7.49375 4.82051 7.57656L6.76739 10.2766Z",
    fill: "#515151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.75H2.25C1.97344 1.75 1.75 1.97344 1.75 2.25V13.75C1.75 14.0266 1.97344 14.25 2.25 14.25H13.75C14.0266 14.25 14.25 14.0266 14.25 13.75V2.25C14.25 1.97344 14.0266 1.75 13.75 1.75ZM13.125 13.125H2.875V2.875H13.125V13.125Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f46a3deae8c142f5814acfb9908ba7fe.svg";
export { ForwardRef as ReactComponent };